import { Link } from 'react-router-dom';

export default function Collections() {
  const collections = [
    {
      name: '女童秋冬季童裝',
      image: 'https://public.readdy.ai/ai/img_res/a76d1aec70a94e4dc5b9fc2bb75f0622.jpg',
      path: '/collections/girls-autumn-winter',
    },
    {
      name: '男童秋冬季童裝',
      image: 'https://readdy.ai/api/search-image?query=Cute%20Korean%20little%20boy%20wearing%20stylish%20autumn%20winter%20outfit%20with%20warm%20hoodie%20jacket%20and%20casual%20pants%20in%20navy%20and%20grey%20tones%20standing%20in%20bright%20clean%20studio%20with%20white%20background%20professional%20product%20photography%20natural%20lighting&width=750&height=1000&seq=col-boys-aw&orientation=portrait',
      path: '/collections/boys-autumn-winter',
    },
    {
      name: '男童春夏季童裝',
      image: 'https://readdy.ai/api/search-image?query=Happy%20smiling%20Asian%20little%20boy%20aged%205%20to%208%20years%20old%20wearing%20bright%20colorful%20spring%20summer%20casual%20wear%20short%20sleeve%20polo%20shirt%20and%20bermuda%20shorts%20in%20sky%20blue%20and%20white%20clean%20minimal%20pure%20white%20studio%20background%20sharp%20focus%20high%20resolution%20children%20fashion%20photography%20vibrant%20colors&width=750&height=1000&seq=col-boys-ss-v2&orientation=portrait',
      path: '/collections/boys-spring-summer',
    },
    {
      name: '女童春夏季童裝',
      image: 'https://readdy.ai/api/search-image?query=Adorable%20Korean%20little%20girl%20wearing%20fresh%20spring%20summer%20dress%20with%20floral%20print%20in%20soft%20pink%20and%20white%20tones%20standing%20in%20bright%20clean%20studio%20with%20white%20background%20professional%20product%20photography%20natural%20lighting&width=750&height=1000&seq=col-girls-ss&orientation=portrait',
      path: '/collections/girls-spring-summer',
    },
    {
      name: '女童連身裙',
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20Korean%20little%20girl%20wearing%20elegant%20princess%20dress%20with%20lace%20details%20and%20puff%20sleeves%20in%20soft%20pink%20and%20white%20colors%20standing%20in%20bright%20clean%20studio%20with%20white%20background%20professional%20product%20photography%20natural%20lighting&width=750&height=1000&seq=col-girls-dress&orientation=portrait',
      path: '/collections/girls-dresses',
    },
    {
      name: '男童外套及褸款',
      image: 'https://readdy.ai/api/search-image?query=Cute%20Asian%20boy%20aged%206%20to%209%20years%20old%20wearing%20premium%20quality%20puffer%20down%20jacket%20coat%20in%20dark%20navy%20color%20with%20zipper%20front%20standing%20straight%20facing%20camera%20isolated%20on%20pure%20white%20background%20ultra%20sharp%20high%20resolution%20professional%20children%20fashion%20catalog%20photography%20studio%20lighting%20perfect%20clarity&width=750&height=1000&seq=col-boys-outer-v5&orientation=portrait',
      path: '/collections/boys-outerwear',
    },
    {
      name: 'BABY BOY 男嬰BB衣衫',
      image: 'https://readdy.ai/api/search-image?query=Adorable%20baby%20boy%20wearing%20soft%20cotton%20romper%20onesie%20with%20cute%20bear%20print%20in%20light%20blue%20and%20white%20pastel%20colors%20lying%20on%20clean%20white%20background%20professional%20product%20photography%20gentle%20natural%20lighting&width=750&height=1000&seq=col-baby-boy&orientation=portrait',
      path: '/collections/baby-boy',
    },
    {
      name: 'BABY GIRL 女嬰BB衫',
      image: 'https://readdy.ai/api/search-image?query=Adorable%20baby%20girl%20wearing%20soft%20cotton%20dress%20with%20delicate%20floral%20print%20in%20light%20pink%20and%20white%20pastel%20colors%20lying%20on%20clean%20white%20background%20professional%20product%20photography%20gentle%20natural%20lighting&width=750&height=1000&seq=col-baby-girl&orientation=portrait',
      path: '/collections/baby-girl',
    },
    {
      name: '皇牌兒童家居服',
      image: 'https://readdy.ai/api/search-image?query=Cute%20Korean%20child%20wearing%20cozy%20soft%20coral%20fleece%20pajama%20set%20with%20cute%20cartoon%20print%20in%20warm%20pastel%20tones%20sitting%20comfortably%20in%20bright%20clean%20studio%20with%20white%20background%20professional%20product%20photography%20natural%20lighting&width=750&height=1000&seq=col-homewear&orientation=portrait',
      path: '/collections/homewear',
    },
    {
      name: '童裝鞋',
      image: 'https://readdy.ai/api/search-image?query=Collection%20of%20cute%20Korean%20children%20shoes%20including%20sneakers%20and%20sandals%20in%20pastel%20pink%20white%20and%20blue%20colors%20neatly%20arranged%20on%20clean%20white%20studio%20background%20professional%20product%20photography%20soft%20natural%20lighting&width=750&height=1000&seq=col-shoes&orientation=portrait',
      path: '/collections/shoes',
    },
    {
      name: '兒童用品',
      image: 'https://readdy.ai/api/search-image?query=Collection%20of%20cute%20Korean%20children%20accessories%20including%20hair%20clips%20backpack%20hat%20and%20socks%20in%20pastel%20colors%20neatly%20arranged%20on%20clean%20white%20studio%20background%20professional%20product%20photography%20soft%20natural%20lighting&width=750&height=1000&seq=col-items&orientation=portrait',
      path: '/collections/kids-items',
    },
  ];

  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center">
          童裝類型 Collections
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {collections.map((collection) => (
            <Link
              key={collection.name}
              to={collection.path}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg bg-gray-100 aspect-[3/4] mb-3">
                <img
                  src={collection.image}
                  alt={collection.name}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <h3 className="text-base font-medium text-gray-900 text-center group-hover:text-amber-600 transition-colors">
                {collection.name}
              </h3>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}